const nav = {
    namespaced: true,

    state: {
        showMobileNav: false,
        breadcrumbs: []
    },

    mutations: {
        TOGGLE_MOBILE_NAV(state) {
            state.showMobileNav = !state.showMobileNav;
        },
        APPLY_BREADCRUMB(state, payload) {
            state.breadcrumbs = payload
        }
    },

    actions: {
        handleNavToggle({ commit }) {
            commit('TOGGLE_MOBILE_NAV')
        },
        applyBreadcrumb({ commit }, array) {
            commit('APPLY_BREADCRUMB', array)
        }
    }
}

export default nav;